import React, { Component } from 'react'
import Intercom from 'react-intercom'
import { inject, observer } from 'mobx-react'

@inject(all => ({
  enabled: all.store.intercom.enabled,
  user: all.store.intercom.user
}))
@observer
class IntercomIntegration extends Component {
  constructor(props) {
    super(props)
    this.state = {
      shown: true
    }
  }

  componentDidMount() {
    if (!this.props.enabled) return null
    return this.handleSwitch()
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.enabled && !prevProps.enabled) {
      this.handleSwitch(true)
    } else if (!this.props.enabled && prevProps.enabled && prevState.shown) {
      this.handleSwitch(false)
    }
  }

  handleSwitch = shown => {
    setTimeout(() => this.setState({ shown }), 0)
  }

  render() {
    if (!this.props.enabled) return null
    if (!this.state.shown) return null
    return <Intercom appID={process.env.INTERCOM_APP_ID} {...this.props.user} />
  }
}

export default IntercomIntegration
